module.exports = __webpack_public_path__ + "static/media/pages.4bd7dde3.svg";